/**
 * Map
 */

import { isOnPage } from './utils';
import { addToCart } from './products';

/* global ymaps */
class CustomCluster {
  // Зададаем макет метки кластера
  createCluster() {
    return ymaps.templateLayoutFactory.createClass(
      '<div class="ymap-cluster-icon"></div>'
    );
  }

  createIconShape() {
    return {
      type: 'Circle',
      coordinates: [0, 0],
      radius: 13,
    };
  }
}

const showLoader = (loader) => {
  loader.classList.add('ajax-loader--visible');
};

const hideLoader = (loader) => {
  loader.classList.remove('ajax-loader--visible');
};

const initMap = () => {
  const location = new URL(window.location);
  const singleObjectEndpoint = `${window.location.origin}/wp-json/motion/v1/get-map-object`;
  const mapObjectsEndpoint = `${window.location.origin}/wp-json/motion/v1/map-objects`;
  const isTouchDevice = matchMedia('(hover: none)').matches;
  const yamapContainer = document.querySelector('#ya-map');
  const ajaxLoader = yamapContainer.querySelector('.ajax-loader');
  const initialCoords = JSON.parse(yamapContainer.dataset.coordinates);
  const clusterer = new CustomCluster();

  const myMap = new ymaps.Map('ya-map', {
    center: initialCoords,
    zoom: 9,
  }, {
    searchControlProvider: 'yandex#search',
    minZoom: 9,
    maxZoom: 19,
  });
  // myMap.controls.remove('searchControl');
  myMap.controls.remove('trafficControl');
  myMap.controls.remove('typeSelector');
  myMap.controls.remove('rulerControl');
  if (isTouchDevice) {
    myMap.behaviors.disable('scrollZoom');
  }
  if (isTouchDevice && window.innerWidth <= 576) {
    myMap.behaviors.disable('drag');
  }

  const objectManager = new ymaps.ObjectManager({
    clusterize: true,
    gridSize: 32,
    clusterDisableClickZoom: true,
  });

  objectManager.objects.options.set('preset', 'islands#blueCircleDotIcon');
  objectManager.clusters.options.set({
    clusterIconLayout: clusterer.createCluster(),
    clusterIconShape: clusterer.createIconShape(),
  });

  const downloadContent = (geoObjects, id, isCluster) => {
    // Создадим массив меток, для которых данные ещё не загружены.
    const objects = geoObjects.filter((geoObject) => geoObject.properties.balloonContentBody === 'Идет загрузка...'
      || geoObject.properties.balloonContentBody === 'Not found');
    // Формируем массив идентификаторов, который будет передан серверу.
    const ids = objects.map((geoObject) => geoObject.id);

    const setNewData = () => {
      if (isCluster && objectManager.clusters.balloon.isOpen(id)) {
        objectManager.clusters.balloon.setData(objectManager.clusters.balloon.getData());
      } else if (objectManager.objects.balloon.isOpen(id)) {
        objectManager.objects.balloon.setData(objectManager.objects.balloon.getData());
      }
    };

    if (ids.length) {
      const months = (location.searchParams.getAll('months[]')) ? location.searchParams.getAll('months[]') : ['apr', 'may', 'jun'];
      ymaps.vow.resolve($.ajax({
        contentType: 'application/json',
        type: 'POST',
        data: JSON.stringify({ objects: ids, months }),
        url: singleObjectEndpoint,
        dataType: 'json',
        processData: false,
      }))
        .then((data) => {
          geoObjects.forEach((geoObject) => {
            const { balloonContentHeader, balloonContentBody } = JSON.parse(data[geoObject.id]);
            geoObject.properties.balloonContentHeader = balloonContentHeader;
            geoObject.properties.balloonContentBody = balloonContentBody;
          });
          setNewData();
        }, () => {
          geoObjects.forEach((geoObject) => {
            geoObject.properties.balloonContent = 'Not found';
          });
          setNewData();
        });
    }
  };

  objectManager.objects.events.add('balloonopen', (e) => {
    const id = e.get('objectId');
    const geoObject = objectManager.objects.getById(id);
    downloadContent([geoObject], id);
  });

  objectManager.clusters.events.add('balloonopen', (e) => {
    const id = e.get('objectId');
    const cluster = objectManager.clusters.getById(id);
    const { geoObjects } = cluster.properties;
    downloadContent(geoObjects, id, true);
  });

  myMap.geoObjects.add(objectManager);

  const updateMap = () => {
    myMap.setBounds(objectManager.getBounds(), { checkZoomRange: true });
  };

  let { searchParams } = (new URL(document.location));
  let searchParamsKeys = Array.from(searchParams.keys());

  if (searchParamsKeys.length === 0 && typeof query_string !== 'undefined') {
    searchParams = (new URL(document.location + '?' + query_string)).searchParams;
    searchParamsKeys = Array.from(searchParams.keys());
  }

  const searchParamsPairs = searchParamsKeys.reduce((acc, key) => {
    if (searchParams.get(key) === '') {
      return acc;
    }
    const value = searchParams.getAll(key);
    acc[key] = (value.length > 1) ? value : value[0];

    return acc;
  }, {});

  const getMapObjects = (offset = 0) => {
    searchParamsPairs.offset = offset;

    $.ajax({
      url: mapObjectsEndpoint,
      data: searchParamsPairs,
      beforeSend() {
        showLoader(ajaxLoader);
      },
      success(data) {
        objectManager.add(data.objects);
        updateMap();
        getMapObjects(data.offset);
      },
      error() {
        hideLoader(ajaxLoader);
      },
    });
  };

  if (isOnPage('#map-objects')) {
    const objects = JSON.parse(document.getElementById('map-objects').innerHTML);
    objectManager.add(objects);
    updateMap();
    hideLoader(ajaxLoader);
  } else {
    getMapObjects();
  }
};

if (isOnPage('#ya-map')) {
  ymaps.ready(initMap);

  document.querySelector('#ya-map').addEventListener('click', (e) => {
    if (e.target.hasAttribute('data-product_id')) {
      e.preventDefault();
      addToCart(e.target);
    }
  });
}
